import React from 'react';

import { observer } from 'mobx-react';
import { getTOS, secondsInTimeFormat } from '@bringg/react-components';
import { Task, TaskStatus, WayPoint } from '@bringg/types';
import FormatDateTimezone from '@bringg/react-components/dist/components/date-display/format-date-timezone';

import { tooltipProvider } from '../tooltip-render-provider';
import useTaskTooltipTranslation from './use-task-tooltip-translation';
import useTimeFormat from 'bringg-web/hooks/use-time-format';
import { timezoneProvider } from 'bringg-web/services/timezone/timezone-provider';

interface TaskTooltipTimesProps {
	task: Task;
	wayPoint: WayPoint;
}

const INVALID_DATE = '--:--';

const TaskTooltipTimes = ({ task, wayPoint }: TaskTooltipTimesProps) => {
	const { eta, tos, etos, arrivedAt } = useTaskTooltipTranslation();
	const hourFormat = useTimeFormat();
	const timeZone = timezoneProvider.getTimezoneByTask(task);

	const TOSDuration = getTOS(wayPoint.checkin_time, wayPoint.checkout_time);
	const tosValue = TOSDuration >= 0 ? secondsInTimeFormat(TOSDuration) : INVALID_DATE;
	const etosValue = wayPoint.etos >= 0 ? secondsInTimeFormat(wayPoint.etos) : INVALID_DATE;

	return (
		<div>
			{task.status === TaskStatus.Done
				? tooltipProvider.renderValue(
						arrivedAt,
						<div>
							<FormatDateTimezone
								date={wayPoint.checkin_time}
								format={'MMM DD, YYYY'}
								timezone={timeZone}
							/>
							,
							<FormatDateTimezone date={wayPoint.checkin_time} format={hourFormat} timezone={timeZone} />
						</div>,

						'arrived-at'
				  )
				: tooltipProvider.renderTime(hourFormat, eta, wayPoint.eta)}

			{task.status === TaskStatus.Done
				? tooltipProvider.renderText(tos, tosValue)
				: tooltipProvider.renderText(etos, etosValue)}
		</div>
	);
};

export default observer(TaskTooltipTimes);
